import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupplierApiTesterService } from './supplier-api-tester.service';

/**
 * Protège l'URL de l'onglet de test : hors compte Predik ou en production,
 * renvoie vers l'onglet par défaut du détail fournisseur.
 */
@Injectable({
  providedIn: 'root',
})
export class SupplierApiTesterGuard {
  constructor(
    private readonly supplierApiTesterService: SupplierApiTesterService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.supplierApiTesterService.isAvailable$().pipe(
      map(available => {
        if (available) {
          return true;
        }
        const parentSegments = route.parent.pathFromRoot.flatMap(snapshot => snapshot.url.map(segment => segment.path));
        return this.router.createUrlTree(['/', ...parentSegments]);
      }),
    );
  }
}
